/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ShoppingWithSocial_shoppingWith = {
    readonly mainImage: string | null;
    readonly title: string | null;
    readonly " $refType": "ShoppingWithSocial_shoppingWith";
};
export type ShoppingWithSocial_shoppingWith$data = ShoppingWithSocial_shoppingWith;
export type ShoppingWithSocial_shoppingWith$key = {
    readonly " $data"?: ShoppingWithSocial_shoppingWith$data;
    readonly " $fragmentRefs": FragmentRefs<"ShoppingWithSocial_shoppingWith">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ShoppingWithSocial_shoppingWith",
  "type": "ShoppingWith",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "mainImage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '8a7f18d6e2fd82dd68041ab51b2639af';
export default node;
